/* eslint-disable max-statements */
import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import queryString, { stringify } from "query-string";
import pickBy from "lodash/pickBy";
import Multiselect from "components/Multiselect";
import { Panel } from "react-bootstrap";
import { formatTimezoneDateTime } from "helper/unit-helper";
import { CustomDateRange } from "components/date-range/index";
import { AppSettings } from "../../constants";
import { Dropdown } from "../../components/Dropdown/Dropdown";
import { CustomDueStatus } from "components/due-status/index";
import Translate from "components/translate";
import { Popup } from "../../components/Popup/popup";
import { Row, Col } from "react-bootstrap";
import InputEditAble from "components/inputEditAble";
import Input from "components/Input";
import * as Vali from "helper/validator-helper";
import { connect } from "react-redux";
import * as AuthActionType from "Auth/constants";

const popupStyle = {
  width: 370,
  height: 185,
};
const savedFilterStyle = {
  width: 500,
  minHeight: 300,
  right: -50,
};
const convertStringMultiParamsToSelectedOption = (stringParams) => {
  let selectedOption = [];
  if (stringParams) {
    const parsedParams = queryString.parse(stringParams);

    Object.keys(parsedParams).map((el) => {
      selectedOption.push(queryString.parse(parsedParams[el]));
    });
  }
  return selectedOption;
};

const TYPES_LIST = [
  { value: "0", text: "Warranty work orders" },
  { value: "1", text: "Blue tape work orders" },
];

class BuilderWorkOrdersFilter extends Component {
  static propTypes = {
    ProjectSelectList: PropTypes.array,
    TradeSelectList: PropTypes.array,
    onFetchProject: PropTypes.func,
    onFilter: PropTypes.func,
    onFetchRegion: PropTypes.func,
    onFetchMarket: PropTypes.func,
    RegionSelectList: PropTypes.array,
    MarketSelectList: PropTypes.array,
    builderUserList: PropTypes.array,
    UserList: PropTypes.array,
    SubcontractorList: PropTypes.array,
    fetchAssignedUsers: PropTypes.func,
    fetchSubcontractors: PropTypes.func,
    onFetchTrade: PropTypes.func,
    onFetchInternalUserSelectList: PropTypes.func,
    onFetchSubcontractorSelectList: PropTypes.func,
    sso: PropTypes.bool,
    location: PropTypes.object,
    LotSelectList: PropTypes.array,
    onFetchLot: PropTypes.func,
    onSaveFilterWO: PropTypes.func,
    onFetchSavedFilter: PropTypes.func,
    SavedFilterList: PropTypes.array,
    onGetSavedFilterProfile: PropTypes.func,
    SavedFilterValueProfile: PropTypes.object,
    onRemoveSavedFilterProfile: PropTypes.func,
    onEditSavedFilterProfile: PropTypes.func,
    onResetFilterName: PropTypes.func,
    idSelected: PropTypes.string,
    WorkOrderStore: PropTypes.object,
    RFSManagedBySelectList: PropTypes.array,
  };

  constructor(props) {
    super(props);

    this.queryParams = queryString.parse(this.props.location.search);

    this.initialStatus = this.queryParams.Status
      ? AppSettings.WO_STATUS_VALUE.map((item) => ({
          label: item.value,
          value: item.key,
        })).filter((x) => this.queryParams.Status.includes(x.value))
      : [];

    // this.initialLot = this.queryParams.inLot
    //   ? queryString.parse(this.queryParams.inLot)
    //   : null;

    this.initialType = this.queryParams.type
      ? queryString.parse(this.queryParams.type)
      : null;

    this.assignedToSelectList = [
      { text: "Subcontractors", value: "sub" },
      { text: "Internal users", value: "internal" },
    ];

    this.initialAssignMode = null;
    if (this.queryParams.inSubcontractors) {
      this.initialAssignMode = this.assignedToSelectList[0];
    } else if (this.queryParams.inAssignedUsers) {
      this.initialAssignMode = this.assignedToSelectList[1];
    } else if (this.queryParams.assignedMode) {
      this.initialAssignMode = queryString.parse(this.queryParams.assignedMode);
    }

    this.state = {
      isLoadingProject: false,
      isShowListSavedFilter: false,
      isShowSaveFilterPopup: false,
      listSavedFilter: [],
      filterName: "",
      isLoadingRFSManagedBy: false,
      panelToggle:
        this.queryParams.inRegions ||
        this.queryParams.inMarkets ||
        this.queryParams.CreatedDateFrom ||
        this.queryParams.ClosedDateFrom ||
        this.queryParams.ResolvedDateFrom
          ? true
          : false,
      ProjectIds: convertStringMultiParamsToSelectedOption(
        this.queryParams.inProjects
      ),
      TradeIds: convertStringMultiParamsToSelectedOption(
        this.queryParams.inTrades
      ),
      RegionIds: convertStringMultiParamsToSelectedOption(
        this.queryParams.inRegions
      ),
      MarketIds: convertStringMultiParamsToSelectedOption(
        this.queryParams.inMarkets
      ),
      Statuses: this.initialStatus,
      SubcontractorIds: convertStringMultiParamsToSelectedOption(
        this.queryParams.inSubcontractors
      ),
      AssignedUserIds: convertStringMultiParamsToSelectedOption(
        this.queryParams.inAssignedUsers
      ),
      lot: convertStringMultiParamsToSelectedOption(this.queryParams.inLot),
      RFSManagedBy: convertStringMultiParamsToSelectedOption(
        this.queryParams.inRFSManagedBy
      ),
      itemRepair: convertStringMultiParamsToSelectedOption(
        this.queryParams.inItemRepair
      ),
      assignedToSelectList: this.assignedToSelectList,
      assignedMode: this.initialAssignMode,
      // dueDate: this.initialDueDate,
      // dueDateSelect: this.initialDueDateSelect,
      customPastDueDate:
        this.queryParams.AgingStatusFrom || this.queryParams.AgingStatusTo
          ? {
              dueStatus: this.queryParams.dueStatus
                ? Number(this.queryParams.dueStatus)
                : null,
              datetime: formatTimezoneDateTime(moment()),
              from: this.queryParams.AgingStatusFrom,
              to: this.queryParams.AgingStatusTo,
              optionType: this.queryParams.ApingStatusType,
            }
          : null,
      appointmentDate:
        this.queryParams.AppointmentDateFrom &&
        this.queryParams.AppointmentDateFrom
          ? {
              from: this.queryParams.AppointmentDateFrom,
              to: this.queryParams.AppointmentDateTo,
              optionType: this.queryParams.AppointmentDateType,
            }
          : null,
      sentDate:
        this.queryParams.SentDateFrom && this.queryParams.SentDateFrom
          ? {
              from: this.queryParams.SentDateFrom,
              to: this.queryParams.SentDateTo,
              optionType: this.queryParams.SentDateType,
            }
          : null,
      createdDate:
        this.queryParams.CreatedDateFrom && this.queryParams.CreatedDateFrom
          ? {
              from: this.queryParams.CreatedDateFrom,
              to: this.queryParams.CreatedDateTo,
              optionType: this.queryParams.CreatedDateType,
            }
          : null,
      closedDate:
        this.queryParams.ClosedDateFrom && this.queryParams.ClosedDateFrom
          ? {
              from: this.queryParams.ClosedDateFrom,
              to: this.queryParams.ClosedDateTo,
              optionType: this.queryParams.ClosedDateType,
            }
          : null,
      resolvedDate:
        this.queryParams.ResolvedDateFrom && this.queryParams.ResolvedDateFrom
          ? {
              from: this.queryParams.ResolvedDateFrom,
              to: this.queryParams.ResolvedDateTo,
              optionType: this.queryParams.ResolvedDateType,
            }
          : null,
      type: this.initialType,
      WODefaultConfig: true,
      // filterSavedProfile: {
      //   name: null,
      //   type: 4,
      //   value: null
      // }
    };
  }

  componentDidMount() {
    this.setState(
      {
        type: this.state.type,
        ["Statuses"]: this.state.Statuses,
      },
      () => {
        this.props.onFilter(this.mapParams());
      }
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.WODefaultConfig == true) {
      if (nextProps.WorkOrderStore && nextProps.WorkOrderStore.WorkOrdersList) {
        let WOstatusValue = [];
        var array = JSON.parse(
          "[" +
            nextProps.WorkOrderStore.WorkOrdersList.params.appliedFilterStatus +
            "]"
        );
        let WODefaultTypeValues = TYPES_LIST.find(
          (x) =>
            x.value ==
            nextProps.WorkOrderStore.WorkOrdersList.params
              .rfswoAssignedModeOrWOType
        );
        let filteredArray = array.includes(null);
        if (!filteredArray) {
          array.map((item) => {
            WOstatusValue.push(
              AppSettings.WO_STATUS_VALUE.find((x) => x.key == item)
            );
            this.setState({
              Statuses: WOstatusValue.map((item) => ({
                label: item.value,
                value: item.key,
              })),
            });
          });
        }
        this.setState({
          type: WODefaultTypeValues,
        });
      }
    }
    const prevUrlParams = queryString.parse(this.props.location.search);
    const nextUrlParams = queryString.parse(nextProps.location.search);

    if (nextProps.RFSManagedBySelectList && this.state.isLoadingRFSManagedBy) {
      this.setState({ isLoadingRFSManagedBy: false });
    }

    // console.log(nextProps.SavedFilterValueProfile, 'nextProps.SavedFilterValueProfile');
    if (
      nextProps.SavedFilterValueProfile !== this.props.SavedFilterValueProfile
    ) {
      if (nextUrlParams.inAssignedUsers === undefined) {
        this.setState({
          assignedMode: null,
        });
      }
      if (nextUrlParams.inSubcontractors === undefined) {
        this.setState({
          assignedMode: null,
        });
      }
    } else {
      if (nextUrlParams.inAssignedUsers !== undefined) {
        this.setState({
          assignedMode: this.assignedToSelectList[1],
        });
      }
      if (nextUrlParams.inSubcontractors !== undefined) {
        this.setState({
          assignedMode: this.assignedToSelectList[0],
        });
      }
    }
    if (nextUrlParams.inProjects !== prevUrlParams.inProjects) {
      this.setState({
        ProjectIds: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inProjects
        ),
      });
    }
    if (nextUrlParams.inAssignedUsers !== prevUrlParams.inAssignedUsers) {
      if (
        nextProps.SavedFilterValueProfile &&
        nextProps.SavedFilterValueProfile.value &&
        nextProps.SavedFilterValueProfile.value.inAssignedUsers &&
        nextUrlParams.inAssignedUsers !== undefined
      ) {
        this.setState({
          AssignedUserIds: convertStringMultiParamsToSelectedOption(
            nextUrlParams.inAssignedUsers
          ),
          assignedMode: this.assignedToSelectList[1],
        });
      }
      this.setState({
        AssignedUserIds: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inAssignedUsers
        ),
      });
    }

    if (nextUrlParams.inSubcontractors !== prevUrlParams.inSubcontractors) {
      if (
        nextProps.SavedFilterValueProfile &&
        nextProps.SavedFilterValueProfile.value &&
        nextProps.SavedFilterValueProfile.value.inSubcontractors &&
        nextUrlParams.inSubcontractors !== undefined
      ) {
        this.setState({
          SubcontractorIds: convertStringMultiParamsToSelectedOption(
            nextUrlParams.inSubcontractors
          ),
          assignedMode: this.assignedToSelectList[0],
        });
      }
      this.setState({
        SubcontractorIds: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inSubcontractors
        ),
      });
    }

    if (nextUrlParams.inRFSManagedBy !== prevUrlParams.inRFSManagedBy) {
      this.setState({
        RFSManagedBy: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inRFSManagedBy
        ),
      });
    }

    if (nextUrlParams.inTrades !== prevUrlParams.inTrades) {
      this.setState({
        TradeIds: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inTrades
        ),
      });
    }

    if (nextUrlParams.inRegions !== prevUrlParams.inRegions) {
      this.setState({
        RegionIds: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inRegions
        ),
      });
    }

    if (nextUrlParams.inMarkets !== prevUrlParams.inMarkets) {
      this.setState({
        MarketIds: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inMarkets
        ),
      });
    }
    if (nextUrlParams.inItemRepair !== prevUrlParams.inItemRepair) {
      this.setState({
        MarketIds: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inItemRepair
        ),
      });
    }

    if (nextUrlParams.Status !== prevUrlParams.Status) {
      if (nextUrlParams.Status) {
        this.setState({
          Statuses: AppSettings.WO_STATUS_VALUE.map((item) => ({
            label: item.value,
            value: item.key,
          })).filter((x) => nextUrlParams.Status.includes(x.value)),
        });
      } else {
        this.setState({ Statuses: [] });
      }
    }

    if (nextUrlParams.inLot !== prevUrlParams.inLot) {
      this.setState({
        lot: convertStringMultiParamsToSelectedOption(nextUrlParams.inLot),
      });
    }

    if (nextUrlParams.type !== prevUrlParams.type) {
      this.setState({
        type: nextUrlParams.type ? queryString.parse(nextUrlParams.type) : null,
      });
    }

    if (nextUrlParams.assignedMode !== prevUrlParams.assignedMode) {
      this.setState({
        assignedMode: nextUrlParams.assignedMode
          ? queryString.parse(nextUrlParams.assignedMode)
          : null,
      });
    }

    if (nextProps.SavedFilterList !== this.props.SavedFilterList) {
      this.setState({
        listSavedFilter: nextProps.SavedFilterList,
      });
    }
  }

  onSelectMultiSelect = (type) => (value) => {
    if (type === "AssignedUserIds") {
      this.setState(
        {
          [type]: value,
          SubcontractorIds: [],
        },
        () => {
          this.props.onFilter(this.mapParams());
        }
      );
    } else if (type === "SubcontractorIds") {
      this.setState(
        {
          [type]: value,
          AssignedUserIds: [],
        },
        () => {
          this.props.onFilter(this.mapParams());
        }
      );
    } else {
      this.setState(
        {
          [type]: value,
          WODefaultConfig: false,
        },
        () => {
          this.props.onFilter(this.mapParams());
        }
      );
    }
  };

  // onChangeDueDateSelect = (event, name) => {
  //   if (event && event.value) {
  //     this.setState(
  //       {
  //         [name]: event.value,
  //         dueDate: {
  //           dueStatus: 1,
  //           datetime: formatTimezoneDateTime(moment())
  //         }
  //       },
  //       () => {
  //         this.props.onFilter(this.mapParams());
  //       }
  //     );
  //   } else {
  //     this.setState(
  //       {
  //         [name]: null,
  //         dueDate: {
  //           dueStatus: '',
  //           datetime: ''
  //         }
  //       },
  //       () => {
  //         this.props.onFilter(this.mapParams());
  //       }
  //     );
  //   }
  // };

  onSelectChange = (event, name) => {
    if (name === "assignedMode") {
      this.setState(
        {
          [name]: event.value,
          AssignedUserIds: [],
          SubcontractorIds: [],
        },
        () => {
          this.props.onFilter(this.mapParams());
        }
      );
    } else if (name === "savedFilter") {
      this.setState({ [name]: event.value }, () => {
        this.props.onFilter(this.mapParams());
      });
    } else {
      if ((event && event.value) || name === "lot") {
        this.setState({ [name]: event.value, WODefaultConfig: false }, () => {
          this.props.onFilter(this.mapParams());
        });
      } else {
        this.setState({ [name]: null });
      }
    }
  };

  onSaveDueStatus =
    (type) => (dueStatus, valueFromPastDue, valueToPastDue, optionType) => {
      if (dueStatus) {
        this.setState(
          {
            [type]: {
              dueStatus: dueStatus,
              datetime: formatTimezoneDateTime(moment()),
              from: null,
              to: null,
              optionType: optionType.value,
            },
            WODefaultConfig: false,
          },
          () => {
            this.props.onFilter(this.mapParams());
          }
        );
      } else if (valueFromPastDue || valueToPastDue) {
        this.setState(
          {
            [type]: {
              dueStatus: null,
              datetime: null,
              from: valueFromPastDue,
              to: valueToPastDue,
              optionType: optionType.value,
            },
            WODefaultConfig: false,
          },
          () => {
            this.props.onFilter(this.mapParams());
          }
        );
      } else {
        this.setState(
          {
            [type]: null,
            WODefaultConfig: false,
          },
          () => {
            this.props.onFilter(this.mapParams());
          }
        );
      }
    };

  onSaveDateRange = (type) => (fromDate, toDate, optionType) => {
    if (fromDate && toDate) {
      this.setState(
        {
          [type]: { from: fromDate, to: toDate, optionType: optionType.value },
          WODefaultConfig: false,
        },
        () => {
          this.props.onFilter(this.mapParams());
        }
      );
    } else {
      this.setState(
        {
          [type]: null,
          WODefaultConfig: false,
        },
        () => {
          this.props.onFilter(this.mapParams());
        }
      );
    }
  };

  mapParams = () => {
    let params = {};
    if (this.state.ProjectIds.length > 0) {
      params["inProjects"] = queryString.stringify([
        ...this.state.ProjectIds.map((el) => queryString.stringify(el)),
      ]);
    }

    const statuses = [];
    if (this.state.Statuses.length > 0) {
      this.state.Statuses.map((e) => {
        statuses.push(e.value);
      });
    }

    if (this.state.SubcontractorIds.length > 0) {
      params["inSubcontractors"] = queryString.stringify([
        ...this.state.SubcontractorIds.map((el) => queryString.stringify(el)),
      ]);
    }

    if (this.state.AssignedUserIds.length > 0) {
      params["inAssignedUsers"] = queryString.stringify([
        ...this.state.AssignedUserIds.map((el) => queryString.stringify(el)),
      ]);
    }

    if (this.state.RegionIds.length > 0) {
      params["inRegions"] = queryString.stringify([
        ...this.state.RegionIds.map((el) => queryString.stringify(el)),
      ]);
    }

    if (this.state.MarketIds.length > 0) {
      params["inMarkets"] = queryString.stringify([
        ...this.state.MarketIds.map((el) => queryString.stringify(el)),
      ]);
    }
    if (this.state.itemRepair.length > 0) {
      params["inItemRepiar"] = queryString.stringify([
        ...this.state.itemRepair.map((el) => queryString.stringify(el)),
      ]);
    }
    if (this.state.TradeIds.length > 0) {
      params["inTrades"] = queryString.stringify([
        ...this.state.TradeIds.map((el) => queryString.stringify(el)),
      ]);
    }

    if (this.state.lot) {
      params["inLot"] = queryString.stringify([
        ...this.state.lot.map((el) => queryString.stringify(el)),
      ]);
    }

    if (this.state.type) {
      params["type"] = queryString.stringify(this.state.type);
    }

    statuses.length
      ? (params["Status"] = statuses.toString())
      : (params["Status"] = "");

    if (this.state.sentDate) {
      params["SentDateFrom"] = this.state.sentDate.from;
      params["SentDateTo"] = this.state.sentDate.to;
      params["SentDateType"] = this.state.sentDate.optionType;
    } else {
      params["SentDateFrom"] = "";
      params["SentDateTo"] = "";
    }
    if (this.state.appointmentDate) {
      params["AppointmentDateFrom"] = this.state.appointmentDate.from;
      params["AppointmentDateTo"] = this.state.appointmentDate.to;
      params["AppointmentDateType"] = this.state.appointmentDate.optionType;
    } else {
      params["AppointmentDateFrom"] = "";
      params["AppointmentDateTo"] = "";
    }
    if (this.state.customPastDueDate) {
      params["dueStatus"] = this.state.customPastDueDate.dueStatus;
      params["datetime"] = this.state.customPastDueDate.datetime;
      params["AgingStatusFrom"] = this.state.customPastDueDate.from;
      params["AgingStatusTo"] = this.state.customPastDueDate.to;
      params["ApingStatusType"] = this.state.customPastDueDate.optionType;
    } else {
      params["dueStatus"] = "";
      params["datetime"] = "";
      params["AgingStatusFrom"] = "";
      params["AgingStatusTo"] = "";
    }
    if (this.state.resolvedDate) {
      params["ResolvedDateFrom"] = this.state.resolvedDate.from;
      params["ResolvedDateTo"] = this.state.resolvedDate.to;
      params["ResolvedDateType"] = this.state.resolvedDate.optionType;
    } else {
      params["ResolvedDateFrom"] = "";
      params["ResolvedDateTo"] = "";
    }
    if (this.state.closedDate) {
      params["ClosedDateFrom"] = this.state.closedDate.from;
      params["ClosedDateTo"] = this.state.closedDate.to;
      params["ClosedDateType"] = this.state.closedDate.optionType;
    } else {
      params["ClosedDateFrom"] = "";
      params["ClosedDateTo"] = "";
    }

    if (this.state.createdDate) {
      params["CreatedDateFrom"] = this.state.createdDate.from;
      params["CreatedDateTo"] = this.state.createdDate.to;
      params["CreatedDateType"] = this.state.createdDate.optionType;
    } else {
      params["CreatedDateFrom"] = "";
      params["CreatedDateTo"] = "";
    }

    if (this.state.assignedMode) {
      params["assignedMode"] = queryString.stringify(this.state.assignedMode);
    }

    if (this.state.RFSManagedBy.length > 0) {
      params["inRFSManagedBy"] = queryString.stringify([
        ...this.state.RFSManagedBy.map((el) => queryString.stringify(el)),
      ]);
    }

    params["WODefaultConfig"] = this.state.WODefaultConfig;

    return params;
  };

  toggleLoading = (type) => {
    this.setState({ [type]: false });
  };

  onFetchProject = () => {
    this.setState(
      {
        isLoadingProject: true,
      },
      () => {
        this.props.onFetchProject(
          () => this.toggleLoading("isLoadingProject"),
          {
            marketIds: this.state.MarketIds.map((el) => el.value),
            regionIds: this.state.RegionIds.map((el) => el.value),
            tradeIds: this.state.TradeIds.map((el) => el.value),
            lotIds: this.state.lot.map((el) => el.value),
            subcontractorIds: this.state.SubcontractorIds
              ? this.state.SubcontractorIds.map((el) => el.value)
              : "",
            userIds: this.state.AssignedUserIds
              ? this.state.AssignedUserIds.map((el) => el.value)
              : "",
          }
        );
      }
    );
  };

  onFetchRegion = () => {
    this.setState(
      {
        isLoadingRegion: true,
      },
      () => {
        this.props.onFetchRegion(() => this.toggleLoading("isLoadingRegion"), {
          projectIds: this.state.ProjectIds.map((el) => el.value),
          marketIds: this.state.MarketIds.map((el) => el.value),
          tradeIds: this.state.TradeIds.map((el) => el.value),
          lotIds: this.state.lot.map((el) => el.value),
          subcontractorIds: this.state.SubcontractorIds
            ? this.state.SubcontractorIds.map((el) => el.value)
            : "",
          userIds: this.state.AssignedUserIds
            ? this.state.AssignedUserIds.map((el) => el.value)
            : "",
        });
      }
    );
  };

  onFetchRFSManagedBy = () => {
    this.setState(
      {
        isLoadingRFSManagedBy: true,
      },
      () => {
        this.props.dispatch({
          type: AuthActionType.SELECT_LISTS_BUILDER_USER_ASYNC,
          params: {
            searchKey: "",
            selectedValue: "",
          },
        });
      }
    );
  };

  onSelectRFSManagedBy = (value) => {
    this.setState(
      {
        RFSManagedBy: value,
        RfsDefaultConfig: false,
        NewRFSFilterFromTiles: "0",
      },
      () => {
        this.props.onFilter(this.mapParams());
      }
    );
  };

  onFetchTrade = () => {
    this.setState(
      {
        isLoadingTrade: true,
      },
      () => {
        this.props.onFetchTrade(() => this.toggleLoading("isLoadingTrade"), {
          regionIds: this.state.RegionIds.map((el) => el.value),
          projectIds: this.state.ProjectIds.map((el) => el.value),
          marketIds: this.state.MarketIds.map((el) => el.value),
          lotIds: this.state.lot.map((el) => el.value),
          subcontractorIds: this.state.SubcontractorIds
            ? this.state.SubcontractorIds.map((el) => el.value)
            : "",
          userIds: this.state.AssignedUserIds
            ? this.state.AssignedUserIds.map((el) => el.value)
            : "",
        });
      }
    );
  };

  onFetchInternalUser = () => {
    this.setState(
      {
        isLoadingInternalUser: true,
      },
      () => {
        this.props.onFetchInternalUserSelectList(
          () => this.toggleLoading("isLoadingInternalUser"),
          {
            regionIds: this.state.RegionIds.map((el) => el.value),
            projectIds: this.state.ProjectIds.map((el) => el.value),
            marketIds: this.state.MarketIds.map((el) => el.value),
            tradeIds: this.state.TradeIds.map((el) => el.value),
            lotIds: this.state.lot.map((el) => el.value),
            subcontractorIds: this.state.SubcontractorIds
              ? this.state.SubcontractorIds.map((el) => el.value)
              : "",
          }
        );
      }
    );
  };

  onFetchSubcontractor = () => {
    this.setState(
      {
        isLoadingSubcontractor: true,
      },
      () => {
        this.props.onFetchSubcontractorSelectList(
          () => this.toggleLoading("isLoadingSubcontractor"),
          {
            regionIds: this.state.RegionIds.map((el) => el.value),
            projectIds: this.state.ProjectIds.map((el) => el.value),
            marketIds: this.state.MarketIds.map((el) => el.value),
            tradeIds: this.state.TradeIds.map((el) => el.value),
            lotIds: this.state.lot.map((el) => el.value),
            userIds: this.state.AssignedUserIds
              ? this.state.AssignedUserIds.map((el) => el.value)
              : "",
          }
        );
      }
    );
  };

  onSelectRegion = (value) => {
    this.setState(
      {
        region: value,
      },
      () => {
        this.props.onFilter(this.mapParams());
      }
    );
  };

  onSelectMarket = (value) => {
    this.setState(
      {
        market: value,
      },
      () => {
        this.props.onFilter(this.mapParams());
      }
    );
  };

  onFetchMarket = () => {
    this.setState(
      {
        isLoadingMarket: true,
      },
      () => {
        this.props.onFetchMarket(() => this.toggleLoading("isLoadingMarket"), {
          projectIds: this.state.ProjectIds.map((el) => el.value),
          regionIds: this.state.RegionIds.map((el) => el.value),
          tradeIds: this.state.TradeIds.map((el) => el.value),
          lotIds: this.state.lot.map((el) => el.value),
          subcontractorIds: this.state.SubcontractorIds
            ? this.state.SubcontractorIds.map((el) => el.value)
            : "",
          userIds: this.state.AssignedUserIds
            ? this.state.AssignedUserIds.map((el) => el.value)
            : "",
        });
      }
    );
  };

  onFetchLot = () => {
    this.setState(
      {
        isLotLoading: true,
      },
      () => {
        this.props.onFetchLot(() => this.toggleLoading("isLotLoading"), {
          projectIds: this.state.ProjectIds.map((el) => el.value),
          marketIds: this.state.MarketIds.map((el) => el.value),
          regionIds: this.state.RegionIds.map((el) => el.value),
          tradeIds: this.state.TradeIds.map((el) => el.value),
          subcontractorIds: this.state.SubcontractorIds
            ? this.state.SubcontractorIds.map((el) => el.value)
            : "",
          userIds: this.state.AssignedUserIds
            ? this.state.AssignedUserIds.map((el) => el.value)
            : "",
        });
      }
    );
  };

  resetFilter = () => {
    this.setState(
      {
        isLoadingProject: false,
        panelToggle: false,
        ProjectIds: [],
        Statuses: [],
        SubcontractorIds: [],
        AssignedUserIds: [],
        RegionIds: [],
        MarketIds: [],
        lot: null,
        assignedMode: null,
        TradeIds: [],
        type: null,
        RFSManagedBy: [],
      },
      () => {
        [
          "appointmentDate",
          "customPastDueDate",
          "sentDate",
          "resolvedDate",
          "closedDate",
          "createdDate",
        ].map((item) => {
          this[item].onReset();
        });
        setTimeout(() => {
          this.props.onResetFilterName();
          this.props.onFilter(this.mapParams());
        }, 0);
      }
    );
  };

  onShowSaveFilterPopup = () => {
    const { isShowSaveFilterPopup } = this.state;
    // if (!this.state.isShowSaveFilterPopup) {
    //   document.addEventListener('click', this.clickOutToCloseShowSaveFilterPopup, false);
    // } else {
    //   document.removeEventListener('click', this.clickOutToCloseShowSaveFilterPopup, false);
    // }
    this.setState({
      isShowSaveFilterPopup: !isShowSaveFilterPopup,
      filterName: null,
    });
  };

  onShowSavedListFilterPopup = () => {
    const { isShowListSavedFilter } = this.state;
    if (!this.state.isShowListSavedFilter) {
      document.addEventListener(
        "mousedown",
        this.clickOutToCloseShowListFilterPopup,
        false
      );
    } else {
      document.removeEventListener(
        "mousedown",
        this.clickOutToCloseShowListFilterPopup,
        false
      );
    }
    this.setState({
      selectedEditFilterId: null,
      isShowListSavedFilter: !isShowListSavedFilter,
    });
  };

  popupSavedFilterList = () => {
    const { isShowListSavedFilter } = this.state;
    this.setState({
      isShowListSavedFilter: !isShowListSavedFilter,
    });
  };

  //HANDLE TO CLICK OUT F**K SIDE
  // clickOutToCloseShowSaveFilterPopup = (e) => {
  // console.log(this.saveFilter, 'ref saveFilter pop up');
  // if (this.saveFilter.contains(e.target) && !this.state.isShowSaveFilterPopup) {
  //   return;
  // }
  // this.onShowSaveFilterPopup();
  // }

  //HANDLE TO CLICK OUT SIDE
  clickOutToCloseShowListFilterPopup = (e) => {
    if (this.showSavedFilter.contains(e.target)) {
      return;
    } else {
      this.onShowSavedListFilterPopup();
    }
  };

  onSaveFilter = () => {
    const searchParams = this.mapParams();
    const filterName = this.state.filterName;

    let data = {};
    data["name"] = filterName.trim();
    data["type"] = 4;
    data["value"] = searchParams;
    this.setState(
      {
        isShowSaveFilterPopup: !this.state.isShowSaveFilterPopup,
        filterName: null,
      },
      () => {
        this.props.onSaveFilterWO(data);
        setTimeout(() => {
          this.props.onFetchSavedFilter();
        }, 500);
      }
    );
  };

  inputNameFilter = (e) => {
    e.preventDefault();
    if (e.target.value.trim() === "") {
      this.setState({
        filterName: null,
      });
    } else {
      this.setState({
        filterName: e.target.value,
      });
    }
  };

  onCancelSaveFilter = () => {
    this.setState({
      isShowSaveFilterPopup: false,
      filterName: null,
    });
  };

  onLoadSavedFilterSelected = (selected) => {
    this.props.onGetSavedFilterProfile(
      {
        filterId: selected.id,
      },
      (extra) => {
        this.props.onFilter({
          ...this.props.SavedFilterValueProfile.value,
          ...extra,
        });
      }
    );
  };

  onRemoveSavedFilter = (selected) => {
    this.props.onRemoveSavedFilterProfile(
      {
        filterId: selected.id,
      },
      () => {
        this.props.onFetchSavedFilter();
        //remove saved filtered when selected
        if (selected.id === this.props.idSelected) {
          this.resetFilter();
        }
      }
    );
  };

  onEditSavedFilterName = (selected) => {
    this.setState({
      selectedEditFilterId: selected.id,
    });
  };

  onEditName = (value) => {
    this.props.onEditSavedFilterProfile(
      {
        id: this.state.selectedEditFilterId,
        name: value.name,
      },
      () => {
        this.setState(
          {
            selectedEditFilterId: null,
          },
          () => this.props.onFetchSavedFilter()
        );
      }
    );
  };

  onCancelEditName = () => {
    this.setState({
      selectedEditFilterId: null,
    });
  };

  onChangeType = (selectedItem) => {
    this.setState({ type: selectedItem.value, WODefaultConfig: false }, () => {
      this.props.onFilter(this.mapParams());
    });
  };

  renderPopupShowSaveFilter = () => {
    return (
      <Popup
        ref={(ref) => {
          this.popup = ref;
        }}
        className="savingFilterWO-popup"
        styles={popupStyle}
      >
        <div
          className="save-filter-popup"
          ref={(ref) => {
            this.saveFilter = ref;
          }}
        >
          <h4>Save filter as </h4>
          <div className="save-filter-popup-body">
            <Col style={{ marginBottom: 5 }} xs={12}>
              <span>Name</span>
            </Col>
            <Col xs={12}>
              <input
                name="filterName"
                className="form-control"
                type="text"
                id="txt-input-name-filter"
                ref={(ref) => {
                  this.inputName = ref;
                }}
                maxLength="254"
                style={{ width: "100%", fontSize: 14 }}
                // value={this.state.filterName}
                onChange={(e) => this.inputNameFilter(e)}
              />
            </Col>
          </div>
          <Col style={{ marginTop: 10 }} xs={12}>
            <button
              onClick={this.onCancelSaveFilter}
              style={{ float: "left", marginTop: 7 }}
              className="btn btn-primary btn-siteone-default"
            >
              Cancel
            </button>
            <button
              disabled={!this.state.filterName}
              onClick={this.onSaveFilter}
              style={{ float: "left", marginTop: 7 }}
              className="btn btn-primary btn-siteone"
            >
              Save
            </button>
          </Col>
        </div>
      </Popup>
    );
  };

  renderUserOption = (userList) => {
    if (userList && userList.length) {
      if (this.props.sso) {
        let systemUsers = [];
        let builderUsers = [];

        userList.map((item) => {
          if (item.extensionValue && item.extensionValue.sso) {
            systemUsers.push(item);
          } else {
            builderUsers.push(item);
          }
        });

        let options = [
          {
            label: "System users",
            options: systemUsers,
          },
          {
            label: "Builder users",
            options: builderUsers,
          },
        ];

        return options;
      } else {
        return userList;
      }
    } else {
      return [];
    }
  };

  renderSavedFilterPopup = () => {
    return (
      <Popup
        ref={(ref) => {
          this.popup = ref;
        }}
        className="showSavedFilter-popup"
        id="saved-list-filter"
        styles={savedFilterStyle}
      >
        <div
          className="col-sm-12 no-padding"
          style={{ marginTop: 10 }}
          ref={(ref) => {
            this.showSavedFilter = ref;
          }}
        >
          <h5 style={{ fontWeight: "bolder", marginLeft: 20 }}>My Reports</h5>
          <div
            className="save-filter-WO-popup custom-group form-group col-sm-12 no-padding"
            style={{ marginBottom: 10 }}
          >
            <ul style={{ listStyle: "none", width: "98%", padding: 0 }}>
              {this.state.listSavedFilter.map((el, index) => (
                <li key={el.id}>
                  {this.state.selectedEditFilterId === el.id ? (
                    <Col xs={12}>
                      <InputEditAble
                        enableFocusOut={true}
                        autoFocus
                        inputName="name"
                        maxLength="254"
                        onSubmit={this.onEditName}
                        onCancel={this.onCancelEditName}
                        defaultValue={el.name}
                      />{" "}
                    </Col>
                  ) : (
                    <Col
                      onClick={() => this.onLoadSavedFilterSelected(el)}
                      className="setting-display-save-filter-name-WO"
                      xs={10}
                    >
                      <span className="filter-name-WO">{el.name}</span>
                    </Col>
                  )}
                  {this.state.selectedEditFilterId === el.id ? null : (
                    <Col style={{ textAlign: "right", marginTop: 9 }} xs={2}>
                      <div className="edit-saved-filter-WO">
                        <i
                          className="fa fa-pencil"
                          onClick={() => this.onEditSavedFilterName(el)}
                        />
                        <i
                          className="fa fa-trash remove-icon func-icon"
                          onClick={() => this.onRemoveSavedFilter(el)}
                        />
                      </div>
                    </Col>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Popup>
    );
  };
  render() {
    const urlParams = queryString.parse(this.props.location.search);
    const averageAge = this.props.WorkOrderStore.WorkOrdersList
      ? this.props.WorkOrderStore.WorkOrdersList.params
        ? Number(
            this.props.WorkOrderStore.WorkOrdersList.params.averageAge
          ).toFixed(2)
        : 0
      : 0;
    return (
      <div className="clearfix sub-work-orders-fillter">
        <Panel expanded={this.state.panelToggle} onToggle={() => {}}>
          <Panel.Heading>
            <Panel.Title>
              Filters &nbsp;
              <div
                onClick={this.resetFilter}
                className="btn btn-siteone-default"
                style={{ marginLeft: 10 }}
              >
                Reset
              </div>
              <div
                onClick={this.onShowSaveFilterPopup}
                className="btn btn-siteone-default"
                style={{ marginLeft: 10 }}
              >
                Save filter as ...
              </div>
              {this.state.isShowSaveFilterPopup &&
                this.renderPopupShowSaveFilter()}
              <span
                style={{
                  display: "inline-block",
                  marginLeft: 10,
                  marginRight: 10,
                }}
              >
                |
              </span>
              <label
                onClick={this.onShowSavedListFilterPopup}
                className="open-saved-filter-list control-label"
              >
                MY REPORTS ({this.state.listSavedFilter.length})
                <i
                  className="pe-7s-angle-down"
                  style={{ fontSize: 30, verticalAlign: "middle" }}
                />
              </label>
              {averageAge >= 0.01 && (
                <label
                  className="open-saved-filter-list control-label"
                  style={{ marginLeft: 30 }}
                >
                  AVERAGE AGE ({averageAge ? averageAge : 0})
                </label>
              )}
              {this.state.isShowListSavedFilter
                ? this.renderSavedFilterPopup()
                : null}
            </Panel.Title>
            <div className="row lot-filter-wrapper" style={{ marginBottom: 0 }}>
              <div className="col-sm-12">
                <div className="col-sm-3 lot-filter-block">
                  <label className="control-label">
                    <Translate translateKey="project" plurals capitalize />
                  </label>
                  <div className="control-label">
                    <Multiselect
                      placeholder="Any"
                      items={this.props.ProjectSelectList.map((item) => ({
                        label: item.text,
                        value: item.value,
                      }))}
                      value={this.state.ProjectIds}
                      onChange={this.onSelectMultiSelect("ProjectIds")}
                      onRemote={this.onFetchProject}
                      isLoading={this.state.isLoadingProject}
                      ref={(ref) => {
                        this.ProjectIds = ref;
                      }}
                    />
                  </div>
                </div>

                <div className="col-sm-3 lot-filter-block">
                  <label className="control-label">Status</label>
                  <div className="control-label">
                    <Multiselect
                      placeholder="Any"
                      items={AppSettings.WO_STATUS_VALUE.map((item) => ({
                        label: item.value,
                        value: item.key,
                      }))}
                      value={this.state.Statuses}
                      onChange={this.onSelectMultiSelect("Statuses")}
                      ref={(ref) => {
                        this.Statuses = ref;
                      }}
                    />
                  </div>
                </div>

                <div className="col-sm-2 lot-filter-block">
                  <label className="control-label">Assigned to</label>
                  <div className="control-label">
                    <Dropdown
                      onChange={(ref) => {
                        this.onSelectChange(ref, "assignedMode");
                      }}
                      className="filestring-dropdown filter-dropdown"
                      options={this.state.assignedToSelectList}
                      optionLabel="text"
                      value={this.state.assignedMode}
                      showClear={true}
                      name="assignedMode"
                      placeholder="Any"
                      style={{ width: "100%", position: "relative" }}
                    />
                  </div>
                </div>
                {this.state.assignedMode && (
                  <div className="col-sm-4 lot-filter-block">
                    <div className="control-label" style={{ marginTop: 24 }}>
                      {this.state.assignedMode.value === "internal" ? (
                        <Multiselect
                          placeholder="Any"
                          items={this.renderUserOption(
                            this.props.builderUserList
                          )}
                          labelKey="text"
                          value={this.state.AssignedUserIds}
                          onRemote={this.onFetchInternalUser}
                          isLoading={this.state.isLoadingInternalUser}
                          onChange={this.onSelectMultiSelect("AssignedUserIds")}
                          ref={(ref) => {
                            this.AssignedUserIds = ref;
                          }}
                        />
                      ) : (
                        <Multiselect
                          placeholder="Any"
                          items={this.props.SubcontractorList.map((item) => ({
                            label: item.text,
                            value: item.value,
                          }))}
                          value={this.state.SubcontractorIds}
                          onChange={this.onSelectMultiSelect(
                            "SubcontractorIds"
                          )}
                          onRemote={this.onFetchSubcontractor}
                          isLoading={this.state.isLoadingSubcontractor}
                          ref={(ref) => {
                            this.SubcontractorIds = ref;
                          }}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="col-sm-12" style={{ marginTop: -5 }}>
                <div className="col-sm-3 lot-filter-block">
                  <label className="control-label">Lot</label>
                  <div className="control-label">
                    <Multiselect
                      placeholder="Any"
                      items={this.props.LotSelectList.map((e) => ({
                        label: e.text,
                        value: e.value,
                      }))}
                      value={this.state.lot}
                      onChange={this.onSelectMultiSelect("lot")}
                      onRemote={this.onFetchLot}
                      isLoading={this.state.isLoadingLot}
                    />
                  </div>
                </div>
                <div className="col-sm-3 lot-filter-block">
                  <label className="control-label">Trades</label>
                  <div className="control-label">
                    <Multiselect
                      placeholder="Any"
                      items={this.props.TradeSelectList.map((item) => ({
                        label: item.text,
                        value: item.value,
                      }))}
                      value={this.state.TradeIds}
                      onChange={this.onSelectMultiSelect("TradeIds")}
                      onRemote={this.onFetchTrade}
                      isLoading={this.state.isLoadingTrade}
                      ref={(ref) => {
                        this.TradeIds = ref;
                      }}
                    />
                  </div>
                </div>

                <div className="col-sm-2 lot-filter-block">
                  <label className="control-label">Type</label>
                  <div className="control-label">
                    <Dropdown
                      name="type_list"
                      style={{ width: "100%" }}
                      className="filestring-dropdown filter-dropdown"
                      value={this.state.type}
                      options={TYPES_LIST}
                      optionLabel="text"
                      placeholder="Any"
                      showClear={true}
                      onChange={this.onChangeType}
                    />
                  </div>
                </div>

                <div className="col-sm-2 lot-filter-block">
                  <label className="control-label">Appointment date</label>
                  <div className="control-label">
                    <CustomDateRange
                      ref={(c) => {
                        this.appointmentDate = c;
                      }}
                      startDate={
                        urlParams.AppointmentDateFrom
                          ? urlParams.AppointmentDateFrom
                          : null
                      }
                      endDate={
                        urlParams.AppointmentDateTo
                          ? urlParams.AppointmentDateTo
                          : null
                      }
                      optionType={
                        urlParams.AppointmentDateType
                          ? urlParams.AppointmentDateType
                          : null
                      }
                      onSave={this.onSaveDateRange("appointmentDate")}
                    />
                  </div>
                </div>

                <div className="col-sm-2 lot-filter-block">
                  <label className="control-label">Aging status</label>
                  <div className="control-label">
                    {/* <Dropdown
                      onChange={ref => {
                        this.onChangeDueDateSelect(ref, 'dueDateSelect');
                      }}
                      className='filestring-dropdown filter-dropdown'
                      options={[{ text: 'Overdue', value: 'overdue' }]}
                      optionLabel='text'
                      value={this.state.dueDateSelect}
                      showClear={true}
                      name='dueDateSelect'
                      placeholder='Any'
                      style={{ width: '100%', position: 'relative' }}
                    /> */}
                    <CustomDueStatus
                      ref={(c) => {
                        this.customPastDueDate = c;
                      }}
                      dueStatus={
                        urlParams.dueStatus ? urlParams.dueStatus : null
                      }
                      fromDate={
                        urlParams.AgingStatusFrom
                          ? urlParams.AgingStatusFrom
                          : null
                      }
                      toDate={
                        urlParams.AgingStatusTo ? urlParams.AgingStatusTo : null
                      }
                      optionType={
                        urlParams.ApingStatusType
                          ? urlParams.ApingStatusType
                          : null
                      }
                      onSave={this.onSaveDueStatus("customPastDueDate")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body style={{ padding: 0 }}>
              <div
                className="row lot-filter-wrapper"
                style={{ marginBottom: 0 }}
              >
                <div className="col-sm-12" style={{ marginTop: -5 }}>
                  {(AppSettings.REGION_AND_MARKET ===
                    AppSettings.RegionAndMarket.REGION ||
                    AppSettings.REGION_AND_MARKET ===
                      AppSettings.RegionAndMarket.REGION_AND_MARKET) && (
                    <div className="col-sm-3 lot-filter-block">
                      <label className="control-label">
                        <Translate translateKey="region" plurals capitalize />
                      </label>
                      <div className="control-label">
                        <Multiselect
                          placeholder="Any"
                          items={this.props.RegionSelectList.map((item) => ({
                            label: item.text,
                            value: item.value,
                          }))}
                          value={this.state.RegionIds}
                          onChange={this.onSelectMultiSelect("RegionIds")}
                          onRemote={this.onFetchRegion}
                          isLoading={this.state.isLoadingRegion}
                          ref={(ref) => {
                            this.RegionIds = ref;
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {AppSettings.REGION_AND_MARKET ===
                    AppSettings.RegionAndMarket.REGION_AND_MARKET && (
                    <div className="col-sm-3 lot-filter-block">
                      <label className="control-label">
                        <Translate translateKey="market" plurals capitalize />
                      </label>
                      <div className="control-label">
                        <Multiselect
                          placeholder="Any"
                          items={this.props.MarketSelectList.map((item) => ({
                            label: item.text,
                            value: item.value,
                          }))}
                          value={this.state.MarketIds}
                          onChange={this.onSelectMultiSelect("MarketIds")}
                          onRemote={this.onFetchMarket}
                          isLoading={this.state.isLoadingMarket}
                          ref={(ref) => {
                            this.MarketIds = ref;
                          }}
                        />
                      </div>
                    </div>
                  )}

                  <div className="col-sm-2 lot-filter-block">
                    <label className="control-label">Creation date</label>
                    <div className="control-label">
                      <CustomDateRange
                        ref={(c) => {
                          this.createdDate = c;
                        }}
                        startDate={
                          urlParams.CreatedDateFrom
                            ? urlParams.CreatedDateFrom
                            : null
                        }
                        endDate={
                          urlParams.CreatedDateTo
                            ? urlParams.CreatedDateTo
                            : null
                        }
                        optionType={
                          urlParams.CreatedDateType
                            ? urlParams.CreatedDateType
                            : null
                        }
                        onSave={this.onSaveDateRange("createdDate")}
                      />
                    </div>
                  </div>

                  <div className="col-sm-2 lot-filter-block">
                    <label className="control-label">Closed date</label>
                    <div className="control-label">
                      <CustomDateRange
                        ref={(c) => {
                          this.closedDate = c;
                        }}
                        startDate={
                          urlParams.ClosedDateFrom
                            ? urlParams.ClosedDateFrom
                            : null
                        }
                        endDate={
                          urlParams.ClosedDateTo ? urlParams.ClosedDateTo : null
                        }
                        optionType={
                          urlParams.ClosedDateType
                            ? urlParams.ClosedDateType
                            : null
                        }
                        onSave={this.onSaveDateRange("closedDate")}
                      />
                    </div>
                  </div>

                  <div className="col-sm-2 lot-filter-block">
                    <label className="control-label">Resolved date</label>
                    <div className="control-label">
                      <CustomDateRange
                        ref={(c) => {
                          this.resolvedDate = c;
                        }}
                        startDate={
                          urlParams.ResolvedDateFrom
                            ? urlParams.ResolvedDateFrom
                            : null
                        }
                        endDate={
                          urlParams.ResolvedDateTo
                            ? urlParams.ResolvedDateTo
                            : null
                        }
                        optionType={
                          urlParams.ResolvedDateType
                            ? urlParams.ResolvedDateType
                            : null
                        }
                        onSave={this.onSaveDateRange("resolvedDate")}
                      />
                    </div>
                  </div>

                  {/** RFS managed by dropdown*/}
                  <div className="col-sm-2 lot-filter-block">
                    <label className="col-sm-12 control-label">
                      RFS managed by
                    </label>
                    <div className="col-sm-12 control-label">
                      <Multiselect
                        placeholder="Any"
                        items={this.renderUserOption(
                          this.props.RFSManagedBySelectList
                        )}
                        labelKey="text"
                        value={this.state.RFSManagedBy}
                        onChange={this.onSelectRFSManagedBy}
                        onRemote={this.onFetchRFSManagedBy}
                        isLoading={this.state.isLoadingRFSManagedBy}
                        ref={(ref) => {
                          this.RFSManagedBy = ref;
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-2 lot-filter-block">
                    <label className="control-label">Sent date</label>
                    <div className="control-label">
                      <CustomDateRange
                        ref={(c) => {
                          this.sentDate = c;
                        }}
                        startDate={
                          urlParams.SentDateFrom ? urlParams.SentDateFrom : null
                        }
                        endDate={
                          urlParams.SentDateTo ? urlParams.SentDateTo : null
                        }
                        optionType={
                          urlParams.SentDateType ? urlParams.SentDateType : null
                        }
                        onSave={this.onSaveDateRange("sentDate")}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Panel.Body>
          </Panel.Collapse>
          <Panel.Footer
            style={{ backgroundColor: "#fff", paddingTop: 0, borderTop: 0 }}
          >
            <div style={{ paddingTop: 0, paddingBottom: 0 }}>
              {this.state.panelToggle ? (
                <div>
                  <span
                    onClick={() => {
                      this.setState({ panelToggle: !this.state.panelToggle });
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fa fa-chevron-circle-up" /> Less
                  </span>
                </div>
              ) : (
                <div>
                  <span
                    onClick={() => {
                      this.setState({ panelToggle: !this.state.panelToggle });
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fa fa-chevron-circle-down" /> More
                  </span>
                </div>
              )}
            </div>
          </Panel.Footer>
        </Panel>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WorkOrderStore: state.WorkOrderReducer,
  };
};

export default connect(mapStateToProps)(BuilderWorkOrdersFilter);



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/BuilderWorkOrderFilters.js